/**
 * DocumentsSpot -- empty-state spot illustration for the document vault (#2580,
 * Tier 5, EPIC #2575). A single sheet with a folded corner and text lines; the
 * folded corner is the brand accent. Line-art on tokens, ~160x120, aria-hidden.
 * Agency-neutral.
 */
import SpotIllustration from "./SpotIllustration";

export function DocumentsSpot({ className }: { className?: string }) {
  return (
    <SpotIllustration className={className}>
      {/* Sheet body (with a notch cut for the folded corner) */}
      <path
        d="M52 22h36l20 20v56H52z"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeOpacity="0.6"
      />
      {/* Folded corner (accent) */}
      <path
        d="M88 22v20h20"
        stroke="var(--color-accent)"
        strokeWidth="2.5"
      />
      {/* Text lines */}
      <path
        d="M62 58h36M62 68h36M62 78h24"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeOpacity="0.45"
      />
    </SpotIllustration>
  );
}

export default DocumentsSpot;
